import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router"
import {
  usePlaybook,
  useSaveVersion,
  withRuleRemoved,
} from "../../-lib/playbook"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete",
)({
  component: DeleteRuleDialog,
})

function DeleteRuleDialog(): React.ReactElement {
  const { playbookId, lineageId } = Route.useParams()
  const { playbook } = usePlaybook(playbookId)
  const { save, pending } = useSaveVersion(playbookId)
  const navigate = useNavigate()
  const version = playbook.latest_version
  const rule = version?.active_rules.find(
    (candidate) => candidate.lineage_id === lineageId,
  )

  if (!version || !rule || version.active_rules.length < 2) {
    return (
      <Navigate
        to="/settings/quoting/playbooks/$playbookId/rules"
        params={{ playbookId }}
        search
        replace
      />
    )
  }

  const close = () =>
    navigate({
      to: "/settings/quoting/playbooks/$playbookId/rules",
      params: { playbookId },
      search: true,
    })

  const confirm = () =>
    save(withRuleRemoved(version, lineageId), "Rule deleted").then(
      (saved) => saved && close(),
    )

  return (
    <ConfirmDialog
      title="Delete this rule?"
      description={`“${rule.content}” is left out of the playbook's next version. Earlier versions keep it.`}
      action="Delete"
      pendingAction="Deleting…"
      pending={pending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
